import Vue from 'vue';

import { config, library, dom } from '@fortawesome/fontawesome-svg-core';
import {
    faSearch,
    faArrowLeft,
    faArrowRight,
    faUser,
    faAt,
    faEnvelope,
    faPhone,
    faChevronRight,
    faChevronDown,
    faChevronUp,
    faCloudUploadAlt,
    faTrashAlt,
    faCheck,
    faTimes,
} from '@fortawesome/free-solid-svg-icons';

config.searchPseudoElements = true;
config.autoReplaceSvg = 'nest';

library.add(faSearch);
library.add(faArrowLeft);
library.add(faArrowRight);
library.add(faUser);
library.add(faAt);
library.add(faEnvelope);
library.add(faPhone);
library.add(faChevronRight);
library.add(faChevronDown);
library.add(faChevronUp);
library.add(faCloudUploadAlt);
library.add(faTrashAlt);
library.add(faCheck);
library.add(faTimes);

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
Vue.component('font-awesome-icon', FontAwesomeIcon);

dom.watch();
